import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../../store';
import ColorPickerListItem from '../../../../../../../list-items/ColorPickerListItem/ColorPickerListItem';

const ImageElementShadowColorListItem = (props) => {
    const { shadowSettingsColor = '0x000000', updateImageElement, index } = props;

    const onShadowColorChange = (color) => {
        const value = color.hex.replace('#', '0x');
        updateImageElement(index, { shadowSettings: { color: value } });
    };

    return (
        <ColorPickerListItem
            text='Color'
            color={shadowSettingsColor.replace('0x', '#')}
            onChange={onShadowColorChange}
            disableAlpha={true}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const imageElement = (state.createPreview.present.videoSettings.elements.imageElements || state.createPreview.present.videoSettings.elements.images)[ownProps.index];
    const shadowSettings = imageElement?.shadowSettings || {};
    return { shadowSettingsColor: shadowSettings.color || '0x000000' };
}

const mapDispatchToProps = (dispatch) => {
    const updateImageElement = (index, properties) => dispatch(createActions.updateImageElement(index, properties));
    return { updateImageElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageElementShadowColorListItem);
